import { createStyles, Text, Container, ActionIcon, Group, Space } from '@mantine/core';
import { IconBrandDiscord, IconBrandGithub } from '@tabler/icons';

import { useStyles } from "../models/styles/FooterStyle";
import {TomSWLogo} from "./TomSWLogo";

interface FooterLinksProps {
    data: {
        title: string;
        links: { label: string; link: string }[];
    }[];
}

export function Footer({ data }: FooterLinksProps) {
    const { classes } = useStyles();

    const groups = data.map((group) => {
        const links = group.links.map((link, index) => (
            <Text<'a'>
                key={index}
                className={classes.link}
                component="a"
                href={link.link}
                onClick={(event) => event.preventDefault()}
            >
                {link.label}
            </Text>
        ));

        return (
            <div className={classes.wrapper} key={group.title}>
                <Text className={classes.title}>{group.title}</Text>
                {links}
            </div>
        );
    });

    return (
        <footer className={classes.footer}>
            <Container className={classes.inner}>
                <div className={classes.logo}>
                    <TomSWLogo width={60} height={50} />
                    <Text size="xs" color="dimmed" className={classes.description}>
                        TomSW Website
                    </Text>
                </div>
                <div className={classes.groups}>{groups}</div>
            </Container>
            <Container className={classes.afterFooter}>
                <Text color="dimmed" size="sm">
                    © 2021 - {new Date().getFullYear()} tomsw.uk, All rights reserved.
                </Text>

                <Group spacing={0} className={classes.social} position="right" noWrap>
                    <IconBrandGithub size={18} stroke={1.5} />
                    <Text p={'xs'} size="xs" color="dimmed" className={classes.description}>
                        Tom-SW1
                    </Text>
                    <IconBrandDiscord size={18} stroke={1.5} />
                    <Text p={'xs'} size="xs" color="dimmed" className={classes.description}>
                        tom_sw
                    </Text>
                </Group>
            </Container>
            <Container>
            <Text color="dimmed" size="sm">
                LEGO® and BrickLink® are trademarks of the LEGO Group. This site is not affiliated with, authorized by, or endorsed by the LEGO Group.
            </Text>
            </Container>
        </footer>
    );
}